import { render } from "./GrossMargin.vue?vue&type=template&id=d1fceb6e&scoped=true"
import script from "./GrossMargin.vue?vue&type=script&lang=js"
export * from "./GrossMargin.vue?vue&type=script&lang=js"

import "./GrossMargin.vue?vue&type=style&index=0&id=d1fceb6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1fceb6e"]])

export default __exports__